import React from "react";
import { Category, LocationScope } from "generated/graphql";
import { Layout } from "views/Main/Layouts";
import { AnalysisCharts } from "collections/AnalysisCharts/AnalysisCharts";
import { useTranslation } from "utilities/i18n";
import { Redirect, Route, Switch } from "polyrouter";

export const SiteAnalysisRouter: React.FC<{
  id: string;
  name: string;
}> = ({ id, name }) => {
  return (
    <Switch>
      <Route nest path="/rooms">
        <SiteAnalysis id={id} name={name} category={Category.Room} />
      </Route>
      <Route nest path="/devices">
        <SiteAnalysis id={id} name={name} category={Category.Device} />
      </Route>
      <Route>
        <Redirect nest to="/rooms" />
      </Route>
    </Switch>
  );
};

const SiteAnalysis: React.FC<{
  id: string;
  category: Category;
  name: string;
}> = ({ id, category, name }) => {
  const { t } = useTranslation();
  const { Content } = Layout;

  return (
    <Content className="site-overview">
      <Content.Title>
        {t("ANALYSIS")} <p>{`| ${name}`}</p>
      </Content.Title>
      <AnalysisCharts
        id={id}
        category={category}
        locationScope={LocationScope.Site}
      />
    </Content>
  );
};
